import Image from 'next/image'
import MinesIcon from '@/public/assets/images/games-icons/mines-icon-96x96.png'
import JackpotIcon from '@/public/assets/images/games-icons/jackpot-icon-96x96.png'
import DoubleIcon from '@/public/assets/images/games-icons/double-icon-96x96.png'
import LootboxIcon from '@/public/assets/images/games-icons/lootbox-icon-96x96.png'
import CoinflioIcon from '@/public/assets/images/games-icons/coinflip-icon-96x96.png'
import RunesIcon from '@/public/assets/images/games-icons/runes-icon-96x96.png'
import PlinkoIcon from '@/public/assets/images/games-icons/plinko-icon-96x96.png'
import KeyIcon from '@/public/assets/icons/key-2.svg'
import { Icon } from '@chakra-ui/react'

export enum Section {
  DOUBLE = 'double',
  MINES = 'mines',
  JACKPOT = 'jackpot',
  LOOTBOX = 'lootbox',
  COINFLIP = 'coinflip',
  RUNES = 'runes',
  PLINKO = 'plinko',
  SIGNATURE = 'signature',
}

export const sections = [
  {
    name: Section.SIGNATURE,
    title: 'common.signature',
    icon: <Icon overflow={'hidden'} lineHeight={1} w={8} mt={1} h={'auto'} as={KeyIcon} />,
  },
  {
    name: Section.DOUBLE,
    title: 'games.double',
    icon: <Image src={DoubleIcon} alt={''} />,
  },
  {
    name: Section.MINES,
    title: 'games.mines',
    icon: <Image src={MinesIcon} alt={''} />,
  },
  {
    name: Section.JACKPOT,
    title: 'games.jackpot',
    icon: <Image src={JackpotIcon} alt={''} />,
  },
  {
    name: Section.LOOTBOX,
    title: 'games.lootbox',
    icon: <Image src={LootboxIcon} alt={''} />,
  },
  {
    name: Section.COINFLIP,
    title: 'games.coinflip',
    icon: <Image src={CoinflioIcon} alt={''} />,
  },
  {
    name: Section.RUNES,
    title: 'games.runes',
    icon: <Image src={RunesIcon} alt={''} />,
  },
  {
    name: Section.PLINKO,
    title: 'games.plinko',
    icon: <Image src={PlinkoIcon} alt={''} />,
  },
]
